import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({
  name: 'FormatCaseNo'
})
@Injectable()//Eg(11-123456)
export class FormatPipe implements PipeTransform {

    transform(value: any): any {

        if (value) {
            var cleaned = ('' + value).replace(/\D/g, '')
            var match = cleaned.match(/^(\d{2})(\d{2})(\d{6})$/);

            return [match[2], '-', match[3]].join('');
        }
        else {
            return '';
        }
    }

}



// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/shared/pipes/format.pipe.ts